import React, { useContext } from 'react';
import { AppContext, DispatchContext } from '../AppContext';
import { makeStyles } from '@material-ui/styles';
import { Box, Link, Typography } from '@material-ui/core';
import { config } from '../helpers/constants';
import * as actions from "../actions/actions";
import { ReactComponent as FilmIcon } from '../assets/icons/film-making.svg';




export default function VideoCard(props) {
    const { title, subtitle, embedId } = props;
    const useStyles = makeStyles(theme => ({
        root: {
            padding: 8,
            width: 250,
            bottom: "8px",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            cursor: () => embedId ? "pointer" : "",
            marginRight: 16,
            marginLeft: 16,
            backgroundColor: "#eeeeee",
            borderRadius: 5
        },
    }));

    const dispatch = useContext(DispatchContext);
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles();

    const color = "#aaaaaa";
    const spacing = 4;

    function openVideoPlayer(title, embedId) {
        dispatch(actions.openLogDialog({
            title: title,
            embedId: embedId,
            cancelLabel: s.common.cancel
        }));
    }    

    return (
        <div onClick={() => embedId && openVideoPlayer(title, embedId) } className={classes.root}>
            <FilmIcon fill="#0D4A81" height={48} style={{ margin: 0 }} />
            <Typography align="center" >{title}</Typography>
            <Typography align="center" variant="body2" color="secondary">{subtitle}</Typography>

        </div>
    );
}
